/**
 * Type of a bug note.
 *
 * Librarised from the legacy `@archipad/backend/project/bugNoteConstant`.
 */
export const BugNoteType = {
    TYPE_UNKNOWN: 0,
    TYPE_COMMENT: 1,
    TYPE_HISTORY: 2,
    TYPE_HISTORY_STATUS: 3,
    TYPE_HISTORY_PHASE: 4,
    TYPE_HISTORY_DOCUMENT: 5,
    TYPE_HISTORY_SIGNOFF: 6,
} as const;
export type BugNoteType = (typeof BugNoteType)[keyof typeof BugNoteType];
